import BrowserCookies from 'js-cookie';

import { LANGUAGE } from '../constants/cookies';

const getLocale = (): string => {
  return BrowserCookies.get(LANGUAGE) || 'de-de';
};

export default getLocale;
